module.exports = __webpack_public_path__ + "img/pin.8192c088.svg";